const c = {
  name: "Qsr",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30,5.6L24.4,0L23,1.4l5,5V10H18v6h2.1l0.2,2.5c-1-0.3-2.1-0.5-3.3-0.5h-4C6.9,18,2,22.9,2,29v1h8
			c-0.8,0-1.4,0.2-1.9,0.4c-0.5,0.2-0.9,0.5-1.2,0.8l0,0c-0.3,0.3-0.6,0.4-0.8,0.6C5.8,31.9,5.5,32,5,32s-0.8-0.1-1.1-0.2
			c-0.3-0.1-0.5-0.3-0.8-0.6l0,0c-0.3-0.2-0.7-0.6-1.2-0.8C1.4,30.2,0.8,30,0,30v2c0.5,0,0.8,0.1,1.1,0.2c0.3,0.1,0.5,0.3,0.8,0.6
			l0,0c0.3,0.2,0.7,0.6,1.2,0.8C3.6,33.8,4.2,34,5,34H2v3c0,1.7,1.3,3,3,3h30.9l2-24H40v-6H30V5.6z M15,34H5c0.8,0,1.4-0.2,1.9-0.4
			c0.5-0.2,0.9-0.5,1.2-0.8l0,0c0.3-0.3,0.6-0.4,0.8-0.6C9.2,32.1,9.5,32,10,32c0.5,0,0.8,0.1,1.1,0.2c0.3,0.1,0.5,0.3,0.8,0.6l0,0
			c0.3,0.2,0.7,0.6,1.2,0.8C13.6,33.8,14.2,34,15,34z M25,34H15c0.8,0,1.4-0.2,1.9-0.4c0.5-0.2,0.9-0.5,1.2-0.8l0,0
			c0.3-0.3,0.6-0.4,0.8-0.6c0.3-0.1,0.6-0.2,1.1-0.2s0.8,0.1,1.1,0.2c0.3,0.1,0.5,0.3,0.8,0.6l0,0c0.3,0.2,0.7,0.6,1.2,0.8
			C23.6,33.8,24.2,34,25,34z M20,30h8v-1c0-4.1-2.3-7.7-5.6-9.6L22.1,16h13.8l-1.8,22h-6.3c0.1-0.3,0.2-0.6,0.2-1v-3h-3
			c0.8,0,1.4-0.2,1.9-0.4c0.5-0.2,0.9-0.5,1.2-0.8l0,0c0.3-0.3,0.6-0.4,0.8-0.6c0.3-0.1,0.6-0.2,1.1-0.2v-2c-0.8,0-1.4,0.2-1.9,0.4
			c-0.5,0.2-0.9,0.5-1.2,0.8l0,0c-0.3,0.3-0.6,0.4-0.8,0.6C25.8,31.9,25.5,32,25,32s-0.8-0.1-1.1-0.2c-0.3-0.1-0.5-0.3-0.8-0.6l0,0
			c-0.3-0.2-0.7-0.6-1.2-0.8C21.4,30.2,20.8,30,20,30z M20,30c-0.8,0-1.4,0.2-1.9,0.4c-0.5,0.2-0.9,0.5-1.2,0.8l0,0
			c-0.3,0.3-0.6,0.4-0.8,0.6C15.8,31.9,15.5,32,15,32c-0.5,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.5-0.3-0.8-0.6l0,0
			c-0.3-0.2-0.7-0.6-1.2-0.8C11.4,30.2,10.8,30,10,30H20z M25,38H5c-0.5,0-1-0.5-1-1v-1h22v1C26,37.5,25.5,38,25,38z M38,14H20v-2
			h18V14z M4.1,28c0.5-4.5,4.3-8,8.9-8h4c4.6,0,8.4,3.5,8.9,8H4.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Qsr
};
